import { DATE_REQUEST_FORMAT } from '../constants/date';
import { IUserForm } from '../views/Profile/components/UserForm/types';

export class UserHelper {
  /**
   * Create a FormData object from an IUserForm object
   *
   * @param data
   * @returns
   */
  static createFormData(data: IUserForm): FormData {
    const formData = new FormData();

    formData.append('firstname', data.firstname);
    formData.append('lastname', data.lastname);
    formData.append('email', data.email);
    formData.append('phone', data.phone);
    formData.append('linkedin', data.linkedin);
    formData.append('address', data.address);
    formData.append('address_secondary', data.address_secondary);
    formData.append('postalcode', data.postalcode);
    formData.append('city', data.city);
    formData.append('country', data.country);
    formData.append('email_secondary', data.email_secondary);
    formData.append('phone_professional', data.phone_professional);

    formData.append('manager[available]', data.available.toString());

    formData.append(
      'manager[birthday]',
      data.birthday ? data.birthday.format(DATE_REQUEST_FORMAT) : '',
    );

    formData.append(
      'manager[date_available]',
      data.date_available ? data.date_available.format(DATE_REQUEST_FORMAT) : '',
    );

    formData.append('cv', data.cv);
    formData.append('cv_fr', data.cv_fr);

    const emptyKeys: any[] = [];

    formData.forEach((val, key) => {
      if (val === '' || val === 'null') {
        emptyKeys.push(key);
      }
    });

    emptyKeys.forEach((val) => {
      formData.delete(val);
    });

    return formData;
  }
}
